import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useNotificationStore } from '../stores/notification.store';
import { useAuthStore } from '../stores/auth.store';

export function NotificationBell() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const setUnreadCount = useNotificationStore((s) => s.setUnreadCount);

  const { data } = useQuery({
    queryKey: ['unread-count'],
    queryFn: () => api.get<{ data: { count: number } }>('/notifications/unread-count'),
    enabled: isAuthenticated,
    refetchInterval: 30_000,
  });

  useEffect(() => {
    if (data?.data?.count !== undefined) {
      setUnreadCount(data.data.count);
    }
  }, [data, setUnreadCount]);

  return null;
}
